import {Divider, Drawer, IconButton, Stack, styled, useTheme} from '@mui/material';
import React from 'react';
import {Close, Check, Remove} from '@mui/icons-material';
import {TalkingPointHeading} from './TalkingPointHeading';
import {TalkingPointDescription} from './TalkingPointDescription';
import {OutlinedButton} from './OutlinedButton';
import {UserTalkingPoint} from '../../declarations/backend/backend.did';
import {VoteEnum} from '../../types';

const DividerLabel = styled('span')(({theme}) => ({
  color: '#6B717E',
  fontSize: theme.typography.pxToRem(14),
}));

const buttonStyles: any = {
  textAlign: 'left',
  transition: 'background 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'flex-end',
  '& svg': {
    mr: 1,
    my: '-2px',
  },
};

type TalkingPointProps = {
  onClose: () => void;
  open: boolean;
  paperCoords: {
    left: number;
    width: number;
  };
  hideBackdrop: boolean;
  data: UserTalkingPoint;
  onSubmit: (id: string, vote: VoteEnum) => void;
};

function TalkingPointPopup({
  data,
  onClose,
  onSubmit,
  open,
  hideBackdrop,
  paperCoords,
}: TalkingPointProps) {
  const theme = useTheme();

  return (
    <Drawer
      PaperProps={{
        sx: {
          left: {md: `${paperCoords.left}px`},
          width: {md: `${paperCoords.width}px`},
          background: 'rgba(255, 255, 255, 0.96)',
          borderRadius: theme.typography.pxToRem(20),
          padding: theme.typography.pxToRem(20),
        },
      }}
      ModalProps={{
        BackdropProps: {
          sx: {
            background: '#0000003D',
            backdropFilter: 'blur(5px)',
          },
        },
      }}
      anchor="bottom"
      hideBackdrop={hideBackdrop}
      open={open}
      onClose={onClose}
    >
      <Stack sx={{mb: 2}} direction="row" alignItems="center" justifyContent="space-between">
        <TalkingPointHeading sx={{mb: 0}}>
          {data.id}. {data.title}
        </TalkingPointHeading>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Stack>
      <TalkingPointDescription>{data.description}</TalkingPointDescription>
      <Divider sx={{mb: 2}}>
        <DividerLabel>cast your vote</DividerLabel>
      </Divider>
      <Stack spacing={2}>
        <OutlinedButton
          sx={{
            ...buttonStyles,
            color: '#fff',
            background: '#21BF80',
            '&:hover': {
              background: '#21BF80cc',
            },
          }}
          onClick={() => onSubmit(data.id, 'yes')}
        >
          <Check fontSize="small" /> Vote yes
        </OutlinedButton>
        <OutlinedButton
          sx={{
            ...buttonStyles,
            background: '#F5DC5D',
            '&:hover': {
              background: '#F5DC5Dcc',
            },
          }}
          onClick={() => onSubmit(data.id, 'abstain')}
        >
          <Remove fontSize="small" /> Abstain from voting
        </OutlinedButton>
        <OutlinedButton
          sx={{
            ...buttonStyles,
            background: '#F76A68',
            color: '#fff',
            '&:hover': {
              background: '#F76A68cc',
            },
          }}
          onClick={() => onSubmit(data.id, 'no')}
        >
          <Close fontSize="small" /> Vote no
        </OutlinedButton>
      </Stack>
    </Drawer>
  );
}

export default TalkingPointPopup;
